<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-11-22 15:48:51
 * @FilePath: 
 * @Description: 通用的财务报表
-->
<template>
  <div class="c-p-t-1 c-p-b-30 full_page">
    <select-store-entrance></select-store-entrance>

    <!-- <div class="depart_tab_con">
      <ul>
        <li
          v-for="(item, index) in departmentList"
          :key="index"
          @click="onClickDepartmentType(item.type)"
          :class="item.Id == nowDepartType ? 'active' : ''"
        >
          {{ item.Name }}
        </li>
      </ul>
    </div> -->
    <div class="financial_data_change" @click="handleChangeReportType">
      <p class="">{{ isRealData ? "实时数据" : "交班数据" }}</p>
      <i class="iconfont icon-qiehuan" />
    </div>
    <date-tab-com
      v-if="!isRealData"
      ref="dateTabRef"
      @change="handleChangeDateType"
      @changeDate="handleChangeDateData"
    ></date-tab-com>

    <div class="total_count_con" v-if="!isRealData">
      <div class="total_bg_con">
        <div class="turnover_con c-m-b-25">
          <p class="c-ft-50 c-m-tb-8 bold">
            {{ turnoverObj.BusinessTotalAmount }}
          </p>
          <p class="c-ft-22">总营业额</p>
        </div>

        <div class="c-f-center c-ft-22">
          <div class="turnover_con c-m-r-20">
            <p class="turnover_money c-ft-34 c-m-tb-8 bold">
              {{ turnoverObj.CashAmount }}
            </p>
            <p>有效营业额收入</p>
          </div>
          <div class="turnover_con">
            <p class="turnover_money c-ft-34 c-m-tb-8 bold">
              {{ turnoverObj.NotCashAmount }}
            </p>
            <p>非营业额收入</p>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="financial_data_con">
      <div class="ticheng_title_con">
        <p class="ticheng_left_con">
          <img
            src="@/assets/financial_image/financial-icon-1.png"
            alt=""
          />营业概况
        </p>
      </div>
      <div class="state_box_con">
        <ul class="business_total_data">
          <li
            v-for="(bItem, bIndex) in businessTotalData"
            :key="bIndex"
            :class="isRealData ? 'business_real_item' : ''"
          >
            <p class="b_title">{{ bItem.Title }}</p>
            <div class="b_count">
              {{
                turnoverObj[bItem.Key] === 0 || turnoverObj[bItem.Key]
                  ? turnoverObj[bItem.Key] +
                    (bItem.Key == "OlnyBathFeePercent" ||
                    bItem.Key == "RepurchasePercent"
                      ? "%"
                      : "")
                  : "--"
              }}
            </div>
            <!-- <div class="b_radio">
              同比

              <span
                :class="
                  turnoverObj[bItem.RatioKey] ? 'red_radio' : 'green_radio'
                "
                >{{ turnoverObj[bItem.RatioKey] }}</span
              >
            </div>
            <div class="b_last_count">
              上期<span>{{ turnoverObj[bItem.LastKey] }}</span>
            </div> -->
          </li>
        </ul>
        <!-- <div class="c-f state_table_title">
          <span class="f-1">名称</span>
          <span class="f-1">合计</span>
          <span class="f-1">与上期同比</span>
        </div>
        <div class="c-flex c-p-lr-32">
          <div class="f-1 state_table_body">
            <p class="c-grey-6">营业额</p>
            <p class="c-grey-6">进店人数</p>
            <p class="c-grey-6">游玩组数</p>
            <p class="c-grey-6">人均消费</p>
            <p class="c-grey-6">门票收入</p>
          </div>
          <div class="f-1 state_table_body">
            <p>{{ visitorsInfo.turnoverRatio }}元</p>
            <p>{{ visitorsInfo.turnoverRatio }}人</p>
            <p>{{ visitorsInfo.turnoverRatio }}组</p>
            <p>{{ visitorsInfo.turnoverRatio }}元</p>
            <p>{{ visitorsInfo.turnoverRatio }}元</p>
          </div>
          <div class="f-1 state_table_body visitor_ratio_col">
            <p
              :class="
                visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
              "
            >
              <span>{{ visitorsInfo.turnoverRatio }}</span
              ><span>元</span>
            </p>
            <p
              :class="
                visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
              "
            >
              <span>{{ visitorsInfo.turnoverRatio }}</span
              ><span>人</span>
            </p>
            <p
              :class="
                visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
              "
            >
              <span>{{ visitorsInfo.turnoverRatio }}</span
              ><span>组</span>
            </p>
            <p
              :class="
                visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
              "
            >
              <span>{{ visitorsInfo.turnoverRatio }}</span
              ><span>元</span>
            </p>
            <p
              :class="
                visitorsInfo.turnoverRatio > 0 ? 'red_radio' : 'green_radio'
              "
            >
              <span>{{ visitorsInfo.turnoverRatio }}</span
              ><span>元</span>
            </p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="financial_data_con" v-if="!isRealData">
      <div class="ticheng_title_con ticheng_title_con_2">
        <p class="ticheng_left_con">
          <img
            src="@/assets/financial_image/financial-icon-2.png"
            alt=""
          />技师上钟/加钟统计分析
        </p>
      </div>
      <div class="state_box_con">
        <ul class="jishi_clock_count">
          <li>
            <p>总人数</p>
            <p>{{ jishiTotalClock }}</p>
          </li>
          <li v-for="(item, index) in jishiClockTypeList" :key="index">
            <p>{{ item.KeyTypeName }}</p>
            <p>{{ item.PersonNum }}</p>
          </li>
        </ul>
        <div class="jishiClock-table">
          <div class="jishiClock-tableHeader">
            <span>类别</span>
            <span v-for="(item, index) in jishiClockCatalogList" :key="index">{{
              item
            }}</span>
          </div>
          <div class="jishiClock-tableContent">
            <ul>
              <li class="content-title">
                <span class="c-ct">排钟数</span>
                <span class="c-ct">排钟金额</span>
                <span class="c-ct">上钟率</span>
                <span class="c-ct">加钟数</span>
                <span class="c-ct">加钟金额</span>
                <span class="c-ct">加钟率</span>
                <span class="c-tr">客单价</span>
              </li>
              <li v-for="(item, index) in jishiClockStaticsList" :key="index">
                <span class="c-ct">{{ item.ClockPaiCount }}</span>
                <span class="c-ct">{{ item.ClockPaiAmount }}</span>
                <span class="c-ct">{{ item.ClockOnPercent }}</span>
                <span class="c-ct">{{ item.ClockAddCount }}</span>
                <span class="c-ct">{{ item.ClockAddAmount }}</span>
                <span class="c-ct">{{ item.ClockAddPercent }}</span>
                <span class="c-tr">{{ item.ClockAvgPrice }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="financial_data_con">
      <div class="ticheng_title_con ticheng_title_con_3">
        <p class="ticheng_left_con">
          <img
            src="@/assets/financial_image/financial-icon-3.png"
            alt=""
          />钟数统计
        </p>
      </div>
      <div class="state_box_con">
        <div class="c-f state_table_title">
          <span class="f-1">类别名称</span>
          <span class="f-1 c-ct">钟数</span>
          <span class="f-1 c-ct">占比</span>
          <span class="f-1 c-tr">金额（元）</span>
        </div>
        <div
          class="c-p-lr-32 c-m-tb-24"
          v-for="(item, index) in clockCountList"
          :key="index"
        >
          <div class="c-flex catalogsNews" @click="handleShowChildTable(item)">
            <div class="f-1 state_table_body clock_name_con">
              <span>{{ item.CatalogName }}</span>

              <span v-if="item.GoodsStatItems && item.GoodsStatItems.length > 0"
                ><img
                  :src="item.isShowChild ? arrowTopImg : arrowBottomImg"
                  alt=""
              /></span>
            </div>
            <div class="f-1 state_table_body c-ct">
              {{ item.Number }}
            </div>
            <div class="f-1 state_table_body c-ct">{{ item.Percent }}%</div>
            <div class="f-1 state_table_body c-tr">
              {{ item.Amount }}
            </div>
          </div>
          <div class="detailedNews" v-if="item.isShowChild">
            <div class="title">
              <i>项目名称</i>
              <!-- 占位用 -->
              <p></p>
              <p>数量</p>
              <p>单价</p>
              <p>原价</p>
              <p>实收</p>
            </div>
            <ul v-for="(items, indexs) in item.GoodsStatItems" :key="indexs">
              <i>{{ items.GoodsName }}</i>
              <!-- 占位用 -->
              <li></li>
              <li>
                {{ items.Number }}
              </li>
              <li>
                {{ items.Price }}
              </li>
              <li>
                {{ items.OldMoney }}
              </li>
              <li>
                {{ items.RealMoney }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="financial_data_con">
      <div class="ticheng_title_con ticheng_title_con_4">
        <p class="ticheng_left_con">
          <img
            src="@/assets/financial_image/financial-icon-4.png"
            alt=""
          />销售统计
        </p>
      </div>
      <div class="state_box_con">
        <div class="c-f state_table_title">
          <span class="f-1">销售类别</span>
          <span class="f-1 c-ct">数量</span>
          <span class="f-1 c-ct">占比</span>
          <span class="f-1 c-tr">金额（元）</span>
        </div>
        <div
          class="c-p-lr-32 c-m-tb-24"
          v-for="(item, index) in incomeTypeList"
          :key="index"
        >
          <div class="c-flex catalogsNews" @click="handleShowChildTable(item)">
            <div class="f-1 state_table_body clock_name_con">
              <span>{{ item.CatalogName }}</span>

              <span v-if="item.GoodsStatItems && item.GoodsStatItems.length > 0"
                ><img
                  :src="item.isShowChild ? arrowTopImg : arrowBottomImg"
                  alt=""
              /></span>
            </div>
            <div class="f-1 state_table_body c-ct">
              {{ item.Number }}
            </div>
            <div class="f-1 state_table_body c-ct">{{ item.Percent }}%</div>
            <div class="f-1 state_table_body c-tr">
              {{ item.Amount }}
            </div>
          </div>
          <div class="detailedNews" v-if="item.isShowChild">
            <div class="title">
              <i>项目名称</i>
              <!-- 占位用 -->
              <p></p>
              <p>数量</p>
              <p>单价</p>
              <p>原价</p>
              <p>实收</p>
            </div>
            <ul v-for="(items, indexs) in item.GoodsStatItems" :key="indexs">
              <i>{{ items.GoodsName }}</i>
              <!-- 占位用 -->
              <li></li>
              <li>
                {{ items.Number }}
              </li>
              <li>
                {{ items.Price }}
              </li>
              <li>
                {{ items.OldMoney }}
              </li>
              <li>
                {{ items.RealMoney }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="financial_data_con">
      <div class="ticheng_title_con ticheng_title_con_5">
        <p class="ticheng_left_con">
          <img
            src="@/assets/financial_image/financial-icon-5.png"
            alt=""
          />营业额对应付款方式统计
        </p>
      </div>
      <div class="state_box_con">
        <div class="c-f-bt state_table_title">
          <span class="">支付方式</span>
          <span class="">金额/元</span>
        </div>
        <div
          class="c-f-bt c-p-lr-32 c-m-tb-24"
          v-for="(item, index) in payMethodsList"
          :key="index"
        >
          <div class="state_table_body">
            {{ item.PayMethodName }}
          </div>
          <div class="state_table_body">
            {{ item.PayAmount }}
          </div>
        </div>
        <!-- <div class="c-f-bt c-p-lr-32 c-m-tb-24">
          <div class="state_table_body">合计</div>
          <div class="state_table_body">
            {{ totalMoney }}
          </div>
        </div> -->
      </div>
    </div>
    <!-- <div class="financial_data_con">
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">会员卡收入按卡种统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">卡种名称</span>
        <span class="f-1">新增数量</span>
        <span class="f-1">新增实收</span>
        <span class="f-1">续卡数量</span>
        <span class="f-1">续卡实收</span>
      </div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(subItem, index) in cardTypeStatisticsItemList"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ subItem.CardTypeName }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.BuyNum }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.BuyRealMoney }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.RenewalNum }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.RenewalRealMoney }}
        </div>
      </div>
    </div>
    </div> -->
    <!-- <div class="financial_data_con">
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">会员卡收入按付款方式统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">付款方式</span>
        <span class="f-1">数量</span>
        <span class="f-1">金额（元）</span>
      </div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(subItem, index) in memberPayMethods"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ subItem.Name }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Number }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Money }}
        </div>
      </div>
    </div>
    </div> -->
    <!-- <div class="financial_data_con">
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">结账人数按手牌统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">手牌名称</span>
        <span class="f-1">人数</span>
        <span class="f-1">占比</span>
      </div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(subItem, index) in handCardTypeList"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ subItem.Name }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Number }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Percent }}
        </div>
      </div>
    </div>
    </div> -->
    <!-- <div class="financial_data_con">
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">项目统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">类别名称</span>
        <span class="f-1">数量</span>
        <span class="f-1">金额（元）</span>
        <span class="f-1">实收（元）</span>
      </div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(item, index) in productList"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ item.GoodsCatalogName }}
        </div>
        <div class="f-1 state_table_body">
          {{ item.Num }}
        </div>
        <div class="f-1 state_table_body">
          {{ item.Money }}
        </div>
        <div class="f-1 state_table_body">
          {{ item.RealMoney }}
        </div>
      </div>
    </div>
    </div> -->
    <!-- <div class="financial_data_con">
    <div class="ticheng_title_con">
      <p class="ticheng_left_con">会员卡种收入统计</p>
    </div>
    <div class="state_box_con">
      <div class="c-f state_table_title">
        <span class="f-1">卡种名称</span>
        <span class="f-1">办卡地</span>
        <span class="f-1">数量</span>
        <span class="f-1">金额（元）</span>
        <span class="f-1">实收（元）</span>
      </div>
      <div class="card_small_title">续卡</div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(subItem, index) in cardTypeList"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ subItem.CardTypeName }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Operatesite }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Num }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Money }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.RealMoney }}
        </div>
      </div>
      <div class="card_small_title">新办</div>
      <div
        class="c-flex c-p-lr-32 c-m-tb-24"
        v-for="(subItem, index) in cardTypeList"
        :key="index"
      >
        <div class="f-1 state_table_body">
          {{ subItem.CardTypeName }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Operatesite }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Num }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.Money }}
        </div>
        <div class="f-1 state_table_body">
          {{ subItem.RealMoney }}
        </div>
      </div>
    </div>
    </div> -->

    <div class="state_box_con" v-if="checkoutPersonList.length > 0">
      <div
        id="myCheckoutChart"
        ref="myCheckoutChart"
        :style="{ width: '100%', height: '300px' }"
      ></div>
    </div>
    <div class="state_box_con c-m-t-10" v-if="incomeTypeList.length > 0">
      <div
        id="myChart"
        ref="myChart"
        :style="{ width: '100%', height: '300px' }"
      ></div>
    </div>

    <div class="state_box_con c-m-t-10" v-if="payMethodsList.length > 0">
      <div
        id="myPieChart"
        ref="myPieChart"
        :style="{ width: '100%', height: '300px' }"
      ></div>
    </div>
  </div>
</template>

<script>
import selectStoreEntrance from "@/newViews/homePage/comps/selectStoreEntrance.vue";

import DateTabCom from "@/newViews/financialStatement/comps/dateTabCom.vue";
import {
  getBaseFinancialData,
  getBaseFinancialRealData,
} from "@/api/performance";
//按需引入
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar"); //条图
require("echarts/lib/chart/pie"); //条图
require("echarts/lib/component/tooltip"); //tooltip
require("echarts/lib/component/legend"); //图例
require("echarts/lib/component/grid"); //图例
require("echarts/lib/component/title"); //图例
export default {
  name: "BaseFinancialStatement",
  props: {},
  data() {
    return {
      departmentList: [
        { Id: 1, Name: "财务部" },
        { Id: 2, Name: "桑拿部" },
      ],
      nowDepartType: 1,
      isRealData: true,
      dateType: 0,
      singleTotalBonus: "--",
      turnoverObj: {},
      visitorsInfo: {
        turnoverRatio: 1224,
      },
      businessTotalData: [],
      businessJiaoData: [
        {
          Title: "总营业额",
          Key: "BusinessTotalAmount",
          RatioKey: "BusinessTotalAmountRatio",
          LastKey: "LastBusinessTotalAmount",
        },
        {
          Title: "进店人数",
          Key: "CheckinNum",
          RatioKey: "CheckinNumRatio",
          LastKey: "LastCheckinNum",
        },
        {
          Title: "离店人数",
          Key: "CheckoutNum",
          RatioKey: "CheckoutNumRatio",
          LastKey: "LastCheckoutNum",
        },
        {
          Title: "人均消费",
          Key: "AvgConsumeAmount",
          RatioKey: "AvgConsumeAmountRatio",
          LastKey: "LastAvgConsumeAmount",
        },
        {
          Title: "净桑人数",
          Key: "OnlyBathFeeNum",
          RatioKey: "OnlyBathFeeNumRatio",
          LastKey: "LastOnlyBathFeeNum",
        },
        {
          Title: "净桑占比",
          Key: "OlnyBathFeePercent",
          RatioKey: "OlnyBathFeePercentRatio",
          LastKey: "LastOlnyBathFeePercent",
        },
        {
          Title: "在店时长",
          Key: "InStoreDuring",
          RatioKey: "InStoreDuringRatio",
          LastKey: "LastInStoreDuring",
        },
        {
          Title: "门票收入",
          Key: "BathFeeAmount",
          RatioKey: "BathFeeAmountRatio",
          LastKey: "LastBathFeeAmount",
        },
        {
          Title: "微会员复购数",
          Key: "RepurchaseTotalNum",
          RatioKey: "BathFeeAmountRatio",
          LastKey: "LastRepurchaseTotalNum",
        },
        {
          Title: "微会员复购率",
          Key: "RepurchasePercent",
          RatioKey: "BathFeeAmountRatio",
          LastKey: "LastRepurchasePercent",
        },
      ],
      businessRealData: [
        // { title: "营业额", key: "BusinesTotal" },
        { Title: "在场人数", Key: "UnPayNumber" },
        { Title: "上班预留", Key: "ReserveNumber" },
        { Title: "本班进店", Key: "CheckinNumber" },
        { Title: "本班离店", Key: "CheckInoutNumber" },
      ],
      jishiTotalClock: "--",
      jishiClockTypeList: [],
      jishiClockCatalogList: [],
      jishiClockStaticsList: [],
      incomeTypeList: [],
      clockCountList: [],
      payMethodsList: [],
      checkoutPersonList: [],
      cardTypeStatisticsItemList: [
        {
          CardTypeName: "连锁-五千卡",
          BuyNum: 3,
          BuyRealMoney: 100,
          RenewalNum: 10,
          RenewalRealMoney: 290,
        },
        {
          CardTypeName: "连锁-一万卡",
          BuyNum: 3,
          BuyRealMoney: 100,
          RenewalNum: 10,
          RenewalRealMoney: 290,
        },
        {
          CardTypeName: "微会员",
          BuyNum: 3,
          BuyRealMoney: 100,
          RenewalNum: 10,
          RenewalRealMoney: 290,
        },
      ],
      memberPayMethods: [
        { Name: "现金", Number: 2, Money: 564 },
        { Name: "微信支付", Number: 2, Money: 564 },
        { Name: "营业额收入", Number: 2, Money: 564 },
        { Name: "非营业额收入", Number: 2, Money: 564 },
      ],
      handCardTypeList: [
        { Name: "男宾", Percenr: "20%", Number: 12 },
        { Name: "女宾", Percenr: "20%", Number: 233 },
        { Name: "男靴", Percenr: "20%", Number: 53 },
        { Name: "女靴", Percenr: "20%", Number: 13 },
        { Name: "儿童", Percenr: "20%", Number: 20 },
      ],

      productList: [
        {
          GoodsCatalogName: "项目1",
          Num: 1,
          Money: 99,
          RealMoney: 199,
        },
      ],
      cardTypeList: [
        {
          CardTypeName: "五千卡",
          Operatesite: "",
          Num: 1,
          Money: 99,
          RealMoney: 199,
        },
      ],
      arrowTopImg: require("@/assets/images/triangleTopArrow.png"),
      arrowBottomImg: require("@/assets/images/triangleBottomArrow.png"),
    };
  },
  components: { selectStoreEntrance, DateTabCom },
  created() {},
  computed: {
    // totalMoney() {
    //   let totalNum = 0;
    //   this.payMethodsList.forEach((element) => {
    //     totalNum += element.PayAmount - 0;
    //   });
    //   return totalNum;
    // },
  },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      this.handleGetSinglePerformance();
    },
  },

  mounted() {
    this.businessTotalData = this.businessRealData;
    this.$nextTick(() => {
      this.vpnId = this.$store.state.vpnId;
      if (this.vpnId) {
        this.handleGetSinglePerformance();
      }
    });
  },
  methods: {
    onClickDepartmentType(type) {
      this.nowDepartType = type;
      this.handleGetSinglePerformance();
    },
    handleChangeDateType(type) {
      this.dateType = type;
      if (this.dateType !== 5) {
        this.handleGetSinglePerformance();
      }
    },
    handleChangeDateData(dateArr) {
      this.startDate = dateArr[0];
      this.endDate = dateArr[1];
      this.handleGetSinglePerformance();
    },
    handleChangeReportType() {
      this.isRealData = !this.isRealData;
      this.businessTotalData = this.isRealData
        ? this.businessRealData
        : this.businessJiaoData;
      this.handleGetSinglePerformance();
    },
    handleGetSinglePerformance() {
      const queryData = {
        VpnId: this.vpnId,
      };
      if (!this.isRealData) {
        if (this.dateType == 5) {
          queryData.BeginTime = this.startDate;
          queryData.EndTime = this.endDate;
        } else {
          queryData.DateType = this.dateType;
        }
      }

      const queryUrl = this.isRealData
        ? getBaseFinancialRealData
        : getBaseFinancialData;
      queryUrl(queryData).then((res) => {
        console.log(res);
        const currentBusinessData = res.CurrentPeriodOverView;
        const lastBusinessData = res.LastPeriodOverView;
        this.turnoverObj = {
          ...currentBusinessData,
          LastBusinessTotalAmount:
            (lastBusinessData && lastBusinessData.BusinessTotalAmount) || "--",
          LastCashAmount:
            (lastBusinessData && lastBusinessData.CashAmount) || "--",
          LastNotCashAmount:
            (lastBusinessData && lastBusinessData.NotCashAmount) || "--",
          LastCheckoutNum:
            (lastBusinessData && lastBusinessData.CheckoutNum) || "--",
          LastCheckinNum:
            (lastBusinessData && lastBusinessData.CheckinNum) || "--",
          LastAvgConsumeAmount:
            (lastBusinessData && lastBusinessData.AvgConsumeAmount) || "--",
          LastOnlyBathFeeNum:
            (lastBusinessData && lastBusinessData.OnlyBathFeeNum) || "--",
          LastOlnyBathFeePercent:
            (lastBusinessData && lastBusinessData.OlnyBathFeePercent) || "--",
          LastInStoreDuring:
            (lastBusinessData && lastBusinessData.InStoreDuring) || "--",
          LastBathFeeAmount:
            (lastBusinessData && lastBusinessData.BathFeeAmount) || "--",
          LastRepurchaseTotalNum:
            (lastBusinessData && lastBusinessData.RepurchaseTotalNum) || "--",
          LastRepurchasePercent:
            (lastBusinessData && lastBusinessData.RepurchasePercent) || "--",
          BusinessTotalAmountRatio: 323,
          CashAmountRatio: 5435,
          NotCashAmountRatio: 5435,
          CheckoutNumRatio: 5435,
          CheckinNumRatio: 5435,
          AvgConsumeAmountRatio: 5435,
          OnlyBathFeeNumRatio: 5435,
          OlnyBathFeePercentRatio: 5435,
          InStoreDuringRatio: 5435,
          BathFeeAmountRatio: 5435,
        };
        console.log(this.turnoverObj);
        if (res.GoodsSaleCatalogList && res.GoodsSaleCatalogList.length > 0) {
          const lastItem =
            res.GoodsSaleCatalogList[res.GoodsSaleCatalogList.length - 1];
          const preItems = res.GoodsSaleCatalogList.slice(
            0,
            res.GoodsSaleCatalogList.length - 1
          );

          preItems.sort(this.compareFunc);
          this.incomeTypeList = preItems.concat(lastItem);
        } else {
          this.incomeTypeList = [];
        }
        this.clockCountList = res.ProductSaleCatalogList || [];
        this.payMethodsList = res.PayMethodItemList || [];
        const clockData = res.ClockAnalysisViewModel;
        this.jishiClockTypeList =
          (clockData && clockData.KeyTypeClockNumbers) || [];

        this.jishiTotalClock = (clockData && clockData.TotalKeyNumber) || "--";
        this.jishiClockStaticsList =
          (clockData && clockData.ClockAnalysisItemList) || [];
        this.jishiClockCatalogList = this.jishiClockStaticsList.map(
          (item) => item.CatalogName
        );
        this.checkoutPersonList = res.KeyTypeCheckoutNumbers || [];

        // this.incomeTypeList = [
        //   {
        //     isShowChild: false,
        //     CatalogName: "休闲收入",
        //     Money: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //     GoodsStatItems: [
        //       {
        //         GoodsName: "足疗1",
        //         Num: 2,
        //         Price: 123,
        //         OldMoney: 231,
        //         RealMoney: 90,
        //       },
        //       {
        //         GoodsName: "足疗2",
        //         Num: 2,
        //         Price: 123,
        //         OldMoney: 231,
        //         RealMoney: 90,
        //       },
        //     ],
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "餐厅收入",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "门票收入",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "男宾助浴",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "女宾助浴",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        // ];

        // this.clockCountList = [
        //   {
        //     isShowChild: false,
        //     CatalogName: "足疗",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //     GoodsStatItems: [
        //       {
        //         GoodsName: "足疗1",
        //         Number: 2,
        //         Price: 123,
        //         OldMoney: 231,
        //         RealMoney: 90,
        //       },
        //       {
        //         GoodsName: "足疗2",
        //         Number: 2,
        //         Price: 123,
        //         OldMoney: 231,
        //         RealMoney: 90,
        //       },
        //     ],
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "中医",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "女宾助浴",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "男宾助浴",
        //     Amount: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        //   {
        //     isShowChild: false,
        //     CatalogName: "美容美体",
        //     Money: "98.00",
        //     Number: 2,
        //     Percnet: "25%",
        //   },
        // ];
        // this.payMethodsList = [
        //   { PayMethodName: "营业额收入", PayAmount: "20866.95" },
        //   { PayMethodName: "微信扫码", PayAmount: "1041.00" },
        //   { PayMethodName: "现金", PayAmount: "531.00" },
        //   { PayMethodName: "POS机", PayAmount: "529.00" },
        //   { PayMethodName: "支付宝扫码", PayAmount: "12318.15" },
        //   { PayMethodName: "纸质门票券", PayAmount: "177.00" },
        //   { PayMethodName: "快手限时47", PayAmount: "141.00" },
        //   { PayMethodName: "美团套票98", PayAmount: "98.00" },
        //   { PayMethodName: "会员卡", PayAmount: "2240.00" },
        // ];
        // this.jishiClockStaticsList = [
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        //   {
        //     ClockPaiCount: 12,
        //     ClockPaiAmount: 200,
        //     ClockOnPercent: 13,
        //     ClockAddCount: 78,
        //     ClockAddAmount: 289,
        //     ClockAddPercent: 29,
        //     ClockAvgPrice: 45,
        //   },
        // ];
        // this.jishiClockCatalogList = [
        //   "采耳",
        //   "美容美体",
        //   "男宾助浴",
        //   "女宾助浴",
        //   "小舒服",
        //   "中医",
        //   "足疗",
        // ];
        if (this.checkoutPersonList.length > 0) {
          this.$nextTick(() => {
            this.initCheckoutChart();
          });
        }
        if (this.incomeTypeList.length > 0) {
          this.$nextTick(() => {
            this.initCharts();
          });
        }
        if (this.payMethodsList.length > 0) {
          this.$nextTick(() => {
            this.initPieCharts();
          });
        }
      });
    },
    handleShowChildTable(item) {
      if (item.GoodsStatItems && item.GoodsStatItems.length > 0)
        this.$set(item, "isShowChild", !item.isShowChild);
      // item.isShowChild = !item.isShowChild;
    },
    initCheckoutChart() {
      this.checkoutPieChart = echarts.init(this.$refs.myCheckoutChart);
      let pieData = [],
        totalCount = 0;
      this.checkoutPersonList.forEach((item) => {
        pieData.push({ value: item.Number, name: item.Name });
        totalCount += item.Number;
        // yData.push(item.Name);
      });
      let option = {
        title: [
          {
            text: "结账人数手牌统计",
            textStyle: {
              fontSize: 16,
              color: "#333",
            },
            left: "center",
          },
          {
            text: totalCount,
            subtext: "总人数",
            textStyle: {
              fontSize: 20,
              color: "#333",
            },
            subtextStyle: {
              fontSize: 12,
              color: "#7A7A7A",
            },
            textAlign: "center",
            x: "44%",
            y: "44%",
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c}人（{d}%）",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 20,
          align: "left",
          bottom: 30,
          textStyle: {
            color: "#7C828A",
          },
          itemWidth: 10,
          itemHeight: 10,
          icon: "circle",
          height: 250,
        },
        series: [
          {
            name: "结账手牌",
            type: "pie",
            // radius: "55%",
            center: ["45%", "50%"],
            radius: ["40%", "65%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{c}人\n{d}%",
                  position: "outer",
                  color: "#7C828A",
                },
                labelLine: {
                  show: true,
                  length: 10,
                  lineStyle: {
                    color: "#D8D8D8",
                  },
                },
              },
            },
            data: pieData,
          },
          // {
          //   name: "",
          //   type: "pie",
          //   center: ["45%", "50%"],
          //   radius: ["40%", "65%"],
          //   clockwise: false, //饼图的扇区是否是顺时针排布
          //   avoidLabelOverlap: false,

          //   label: {
          //     normal: {
          //       formatter: "{c}\n{d}%",
          //       show: true,
          //       position: "",
          //     },
          //   },
          //   itemStyle: {
          //     normal: {
          //       label: {
          //         show: true,
          //         formatter: "{c}\n{d}%",
          //         position: "outer",
          //       },
          //       labelLine: {
          //         show: true,
          //         length: 10,
          //       },
          //     },
          //   },
          //   // labelLine: {
          //   //   show: true,
          //   //   length: 20,
          //   //   length2: 15,
          //   //   smooth: true,
          //   //   lineStyle: {
          //   //     color: "#D8D8D8",
          //   //   },
          //   // },
          //   data: pieData,
          // },
        ],
      };
      this.checkoutPieChart.setOption(option);
    },
    compareFunc(a, b) {
      // 使用 toUpperCase()忽略字符大小写
      const genreA = a.Amount;
      const genreB = b.Amount;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = -1;
      } else if (genreA < genreB) {
        comparison = 1;
      }
      return comparison;
    },
    initCharts() {
      // this.chart = echarts.init(document.getElementById('myChart'))
      this.chart = echarts.init(this.$refs.myChart);
      let xData = [],
        yData = [];

      this.incomeTypeList.forEach((item) => {
        if (item.CatalogName != "合计") {
          xData.push(item.CatalogName);
          yData.push(item.Amount);
        }
      });
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: "{b0}: {c0}",
          borderRadius: 200,
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0], "top"];
          },
          padding: [10, 20, 10, 20],
        },
        title: [
          {
            text: "收入按项目类别统计图",
            textStyle: {
              fontSize: 16,
              color: "#333",
            },
            left: "center",
          },
        ],
        legend: { show: false },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            data: xData,
          },
        ],
        yAxis: [
          {
            name: "项目类别",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "营业额",
            type: "bar",
            radius: "55%",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // position: "right",
                  formatter: "{c}元",
                },
                barBorderRadius: [6, 6, 6, 6],
                color: "#147AD6",
              },
            },
            label: {
              normal: {
                show: false,
                lineHeight: 20,
                height: 20,
                backgroundColor: "rgba(0,160,221,0.1)",
                borderRadius: 200,
                position: "top",
                padding: [0, 10, 0, 10],
              },
            },
            data: yData,
            // barMaxWidth: 30,
          },
        ],
      };
      this.chart.setOption(option);
    },
    initPieCharts() {
      // this.chart = echarts.init(document.getElementById('myChart'))
      this.pieChart = echarts.init(this.$refs.myPieChart);
      let xData = [],
        yData = [];
      this.payMethodsList.forEach((item) => {
        if (item.PayAmount != 0 && item.PayMethodName != "合计") {
          xData.push({ value: item.PayAmount, name: item.PayMethodName });
        }
        // yData.push(item.Name);
      });
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}：{c}元（{d}%）",
        },
        title: [
          {
            text: "收入按付款方式统计图",
            textStyle: {
              fontSize: 16,
              color: "#333",
            },
            left: "center",
          },
        ],
        // legend: {
        //   show: true,
        //   x: "center",
        //   // y: 40,
        //   data: yData,
        // },
        legend: {
          bottom: "1%",
          left: "center",
        },
        series: [
          {
            name: "收入付款方式",
            type: "pie",
            // radius: "55%",
            radius: ["30%", "50%"],
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{c}元\n{d}%",
                  position: "outer",
                  color: "#7C828A",
                },
                labelLine: {
                  show: true,
                  length: 10,
                  lineStyle: {
                    color: "#D8D8D8",
                  },
                },
              },
            },
            center: ["50%", "42%"],
            data: xData,
          },
        ],
      };
      this.pieChart.setOption(option);
    },
  },
};
</script>
<style scoped lang="scss">
.depart_tab_con {
  width: 100%;
  overflow-x: scroll;
  padding: 20px 30px;
  box-sizing: border-box;
  &::-webkit-scrollbar {
    display: none;
  }

  ul {
    display: flex;
    li {
      padding: 10px 0;
      margin-right: 30px;
      &.active {
        position: relative;
        &:after {
          position: absolute;
          bottom: -10px;
          left: 0;
          content: "";
          width: 100%;
          height: 12px;
          background: #5dcdff;
          border-radius: 10px;
          opacity: 0.8;
        }
      }
    }
  }
}
.state_blue_color {
  color: #5ccdff;
}
.financial_data_change {
  display: flex;
  align-items: center;
  padding: 20px 32px;
  color: #ff8700;
  font-size: 26px;
  .iconfont {
    margin-left: 12px;
    font-size: 24px;
  }
}
.total_count_con {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #333;
  .total_bg_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 556px;
    height: 556px;
    background: url("../../assets/financial_image/financial-total-bg.png")
      no-repeat;
    background-size: 100% 100%;
  }

  // padding: 58px 0 56px !important;
  .turnover_con {
    display: flex;
    flex-direction: column;
    text-align: center;
    transform: translateY(-17px);
    p {
      &:last-child {
        color: #7a7a7a;
      }
    }
  }
}
.state_box_con {
  background: #ffffff;

  padding-bottom: 1px;
}
.financial_data_con {
  box-shadow: 0px 4px 10px 0px rgba(153, 151, 151, 0.3);
  margin: 0 32px 32px;
  border-radius: 16px;
  overflow: hidden;
}
.ticheng_title_con {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 24px;
  // background: #fff;
  font-size: 28px;
  font-weight: bold;
  color: #333;

  background: linear-gradient(90deg, #e6efff 0%, #ffffff 100%);
  &.ticheng_title_con_2 {
    background: linear-gradient(90deg, #fff4e8 0%, #ffffff 100%);
  }
  &.ticheng_title_con_3 {
    background: linear-gradient(90deg, #e8faff 0%, #ffffff 100%);
  }
  &.ticheng_title_con_4 {
    background: linear-gradient(90deg, #e7f0ff 0%, #ffffff 100%);
  }
  &.ticheng_title_con_5 {
    background: linear-gradient(90deg, #fff4e8 0%, #ffffff 100%);
  }
  .ticheng_left_con {
    // padding-left: 20px;
    position: relative;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      vertical-align: -10px;
    }
  }
}
.business_total_data {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 30px;
  li {
    width: 32%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 0;
    // border-bottom: 1px solid #d8d8d8;
    position: relative;
    // &::after {
    //   content: "";
    //   width: 1px;
    //   height: 88px;
    //   position: absolute;
    //   right: 0;
    //   top: 50%;
    //   margin-top: -44px;
    //   background: #d8d8d8;
    // }
    &:last-child {
      border-bottom: none;
      &::after {
        height: 0;
      }
    }
    &:nth-child(3n) {
      &::after {
        height: 0;
      }
    }
    &:nth-last-child(2) {
      border-bottom: none;
    }
    &.business_real_item {
      width: 25%;
    }
    .b_title {
      font-size: 24px;
      color: #7a7a7a;
    }
    .b_count {
      font-size: 40px;
      margin: 15px 0;
      color: #333;
      font-weight: bold;
    }
    .b_radio {
      font-size: 20px;
      color: #7a7a7a;
      margin-bottom: 13px;
    }
    .b_last_count {
      font-size: 20px;
      color: #7a7a7a;
      span {
        color: #333;
      }
    }
  }
}
.state_table_title {
  padding: 25px 32px;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #ebedf0;
  font-size: 24px;
}
.card_small_title {
  padding: 20px 0;
  font-size: 28px;
  text-align: center;
  font-weight: bold;
}
.state_table_body {
  color: #333;
  font-size: 24px;
  p {
    margin: 13px 0;
    height: 48px;
    line-height: 48px;
  }
}
.visitor_ratio_col {
  p {
    width: 100%;
    border-radius: 4px;
    padding: 0 8px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    &.red_radio {
      background: #fe2207;
    }
    &.green_radio {
      background: #3ae340;
    }
  }
}
.jishi_clock_count {
  display: flex;
  flex-wrap: wrap;
  padding: 35px 20px 0;
  li {
    width: 25%;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    text-align: center;
    margin-bottom: 25px;
    font-size: 26px;
    position: relative;
    p {
      color: #7a7a7a;
      &:last-child {
        font-weight: bold;
        color: #333;
        margin-top: 15px;
        font-size: 36px;
      }
    }
    &::after {
      content: "";
      width: 1px;
      height: 64px;
      position: absolute;
      right: 0;
      top: 50%;
      margin-top: -40px;
      background: #d8d8d8;
    }
    &:last-child {
      &::after {
        height: 0;
      }
    }
    &:nth-child(4n) {
      &::after {
        height: 0;
      }
    }
  }
}

.jishiClock-table {
  display: flex;
  width: 100%;
  // border-top: 1px solid #eaeaea;
  // border-bottom: 1px solid #eaeaea;
  box-sizing: border-box;
  padding: 0 20px;
  .jishiClock-tableHeader {
    display: flex;
    flex-flow: column wrap;
    width: 20%;
    > span {
      flex: 1;
      height: 70px;
      line-height: 70px;
      font-size: 24px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // border-right: 1px solid #eaeaea;
    }
  }

  .jishiClock-tableContent {
    flex: 1;
    overflow-x: scroll;
    > ul {
      > li {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        height: 70px;
        padding: 0 10px;
        > span {
          flex: none;
          height: 70px;
          line-height: 70px;
          width: 100px;
          font-size: 24px;
          padding-right: 20px;
        }
      }
    }
  }
}
.detailedNews {
  width: 100%;
  color: #666;
  font-size: 24px;
  line-height: 70px;
  overflow-x: scroll;
  box-sizing: border-box;
  border-left: 1px solid #ddd;
  margin-top: 20px;
  .title {
    font-weight: bold;
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
  ul {
    border-bottom: 1px solid #ddd;
  }
  ul,
  .title {
    width: 1000px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    i {
      position: absolute;
      left: 66px;
      background: #fff;
      font-weight: bold;
      text-align: left !important;
    }
    i,
    p,
    li {
      width: 200px;
      height: 70px;
      padding: 0 10px;
      line-height: 70px;
      text-align: center;
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      box-sizing: border-box;
      border-right: 1px solid #ddd;
    }
  }
}
.clock_name_con {
  display: flex;
  align-items: center;
  img {
    width: 30px;
    height: 30px;
    margin-left: 5px;
  }
}
</style>
